import { markCurrentConversationAsRead } from "./markCurrentConversationAsRead"

export const FETCH_CURRENT_CONVERSATION_MESSAGES_BEGIN = 'FETCH_CURRENT_CONVERSATION_MESSAGES_BEGIN'
export const FETCH_CURRENT_CONVERSATION_MESSAGES_SUCCESS = 'FETCH_CURRENT_CONVERSATION_MESSAGES_SUCCESS'
export const FETCH_CURRENT_CONVERSATION_MESSAGES_FAILED = 'FETCH_CURRENT_CONVERSATION_MESSAGES_FAILED'

const fetchCurrentConversationMessagesBegin =   (payload) => ({ type: FETCH_CURRENT_CONVERSATION_MESSAGES_BEGIN, payload })
const fetchCurrentConversationMessagesSuccess = (payload) => ({ type: FETCH_CURRENT_CONVERSATION_MESSAGES_SUCCESS, payload })
const fetchCurrentConversationMessagesFailed =  (payload) => ({ type: FETCH_CURRENT_CONVERSATION_MESSAGES_FAILED, payload })

export const fetchCurrentConversationMessages = (conversation, showLoading=true) => {
  return (dispatch, getState) => {
    const { organization } = getState()
    dispatch(fetchCurrentConversationMessagesBegin({loading: showLoading}))
    $.ajax({
      url:  `/api/staff/v1/conversations/${conversation.id}/messages.json?q[s]=created_at+desc`,
      success: (response) => {
        dispatch(fetchCurrentConversationMessagesSuccess(response))
        dispatch(markCurrentConversationAsRead())
      },
      error: () => dispatch(fetchCurrentConversationMessagesFailed())
    })
  }
}